module.exports = __webpack_public_path__ + "res/ic_menu_play_s.afccd64e6539592fb124754673fdd46b.png";